import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormControl, Modal, Table } from 'react-bootstrap';
import StepNav from './StepNav.jsx';

const AddProjectModalMapSettings = ({
	steps,
	step,
	confirmAndClose,
	next,
	addProjectOverlayFileChange,
	activityCodeTypes,
	updateAreaProperty,
	kmlIconWarning
}) => {
	const areaPropertyOptions = Object.keys(activityCodeTypes).map(activityCodeTypeId => {
		return <option key={activityCodeTypeId} value={activityCodeTypeId}>{activityCodeTypes[activityCodeTypeId]}</option>;
	});
	return (
		<React.Fragment>
			<Modal.Body>
				<StepNav steps={steps} step={step} />
				<Table className="projectSetupTable">
					<tbody>
						<tr>
							<td>Choose an Overlay File</td>
							<td>
								<FormControl
									componentClass="input"
									onChange={addProjectOverlayFileChange}
									type="file"
									label="Overlay File" />
							</td>
						</tr>
						<tr>
							<td>Area Activity Code Type</td>
							<td>
								<FormControl
									componentClass="select"
									onChange={event => {
										updateAreaProperty(event.target.value);
									}}>
									<option key="" value="">Choose Area Activity Code Type</option>
									{areaPropertyOptions}
								</FormControl>
							</td>
						</tr>
						{kmlIconWarning && kmlIconWarning.length
							? (
								<tr>
									<td colSpan={2}>
										<div className="alert alert-warning" role="status">
											<p>
												Local icon files in the KML will be replaced with standard map pins.
												The original file is kept.
											</p>
											<ul>
												{kmlIconWarning.map(href => <li key={href}>{href}</li>)}
											</ul>
										</div>
									</td>
								</tr>
							)
							: null}
					</tbody>
				</Table>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={confirmAndClose} bsStyle="danger" className="floatLeft">Cancel</Button>
				<Button bsStyle="primary" onClick={next}>Next</Button>
			</Modal.Footer>
		</React.Fragment>
	);
};

AddProjectModalMapSettings.propTypes = {
	steps: PropTypes.array,
	step: PropTypes.number,
	confirmAndClose: PropTypes.func,
	next: PropTypes.func,
	addProjectOverlayFileChange: PropTypes.func,
	activityCodeTypes: PropTypes.objectOf(PropTypes.string),
	updateAreaProperty: PropTypes.func,
	kmlIconWarning: PropTypes.arrayOf(PropTypes.string)
};

export default AddProjectModalMapSettings;